import React from 'react';

const FormLayout = ({children ,heading}) => {
    return (
        <div className="form__layout-login">
            <h1 className="form__layout-heading text-jost-sb-50">{heading}</h1>
            <div className="form__layout-container">
                {children}
            </div>
        </div>
    );
};

export default FormLayout;
